"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitString = void 0;
function splitString(stringValue, delimiter) {
    const v = [];
    let s = '';
    let pos = 0;
    let quoteChar = null;
    while (pos < stringValue.length) {
        if (quoteChar === null &&
            (stringValue.charAt(pos) === '"' || stringValue.charAt(pos) === "'")) {
            quoteChar = stringValue.charAt(pos++);
            continue; // Skip the quote.
        }
        else if (quoteChar === null &&
            stringValue.charAt(pos) === '\\' &&
            pos + 1 < stringValue.length &&
            (stringValue.charAt(pos + 1) === '"' || stringValue.charAt(pos + 1) === "'")) {
            ++pos; // Skip the backslash
        }
        else if (quoteChar !== null &&
            stringValue.charAt(pos) === '\\' &&
            pos + 1 < stringValue.length &&
            stringValue.charAt(pos + 1) === quoteChar) {
            ++pos; // Skip the backslash
        }
        else if (quoteChar !== null && stringValue.charAt(pos) === quoteChar) {
            ++pos;
            quoteChar = null;
            continue; // Skip the quote.
        }
        else if (delimiter.indexOf(stringValue.charAt(pos)) !== -1) {
            if (quoteChar === null) {
                ++pos;
                if (s.length > 0) {
                    v.push(s);
                    s = '';
                }
                continue;
            }
        }
        if (pos < stringValue.length) {
            s += stringValue.charAt(pos++);
        }
    }
    if (s.length > 0) {
        v.push(s);
    }
    if (quoteChar !== null) {
        return null; // Unmatched quote.
    }
    return v;
}
exports.splitString = splitString;
//# sourceMappingURL=split-string.js.map